import { Meta, Title } from "@solidjs/meta";
import type { Component } from "solid-js";
import { getAppBaseUrl } from "~/lib/getAppBaseUrl";
import { getSocialCardImageUrl } from "~/lib/socialCard";
import { sharedChatMetaTitle } from "./sharedChatMetaTitle";

interface SharedChatMetaProps {
  title?: string;
  section?: string;
  url: string;
}

const imageUrl = () => getSocialCardImageUrl(getAppBaseUrl());

/**
 * SharedChatMeta renders Open Graph and Twitter Card meta tags for shared chats.
 * These meta tags enable rich previews when the link is shared on social media platforms.
 *
 * The component uses @solidjs/meta's Title and Meta components which inject into <head>
 * during SSR, ensuring social media crawlers see the correct metadata.
 */
export const SharedChatMeta: Component<SharedChatMetaProps> = (props) => {
  const title = () => sharedChatMetaTitle(props.title, props.section);
  const fullTitle = () => `${title()} | Chief`;

  return (
    <>
      <Title>{fullTitle()}</Title>
      {/* Open Graph tags */}
      <Meta property="og:title" content={title()} />
      <Meta property="og:type" content="article" />
      <Meta property="og:url" content={props.url} />
      <Meta property="og:site_name" content="Chief" />
      <Meta property="og:image" content={imageUrl()} />
      {/* Twitter Card tags */}
      <Meta name="twitter:card" content="summary_large_image" />
      <Meta name="twitter:title" content={title()} />
      <Meta name="twitter:image" content={imageUrl()} />
    </>
  );
};
